import queryString from 'querystring';

import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";


let redux = reduxCreator.type('FORUM_TOPIC_FOLLOW').plugin(axiosPlugin);

let createForumTopicFollowAction = redux.fetchActionCreate();

let deleteForumTopicFollowAction = redux.fetchActionDelete();

export const addForumTopicFollow = (forumId, topicId, query = {}) => createForumTopicFollowAction(`/forums/${forumId}/topics/${topicId}/follow?${queryString.stringify(query)}`);
export const removeForumTopicFollow = (forumId, topicId, query = {}) => deleteForumTopicFollowAction(`/forums/${forumId}/topics/${topicId}/follow?${queryString.stringify(query)}`);
export const resetForumTopicFollow = () => redux.actions.reset();

export const forumTopicFollow = redux.reducer();